/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Callback_PlaceholderInputs */

const id_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halo /auth/callback!`)
};

const ms_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halo /auth/callback!`)
};

const da_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hej /auth/callback!`)
};

const de_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallo /auth/callback!`)
};

const en_us2_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hello /auth/callback!`)
};

const es_es2_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hola /auth/callback!`)
};

const es_mx2_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hola /auth/callback!`)
};

const fil_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hello /auth/callback!`)
};

const fr_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonjour /auth/callback !`)
};

const it_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciao /auth/callback!`)
};

const hu_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szia /auth/callback!`)
};

const nl_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallo /auth/callback!`)
};

const no_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hei /auth/callback!`)
};

const pl_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Witaj /auth/callback!`)
};

const pt_br2_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olá /auth/retorno de chamada!`)
};

const pt_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olá /auth/callback!`)
};

const ro_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salut /auth/callback!`)
};

const fi_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hei /auth/callback!`)
};

const sv_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hej /auth/callback!`)
};

const vi_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xin chào /auth/callback!`)
};

const tr_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merhaba /auth/callback!`)
};

const cs_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahoj /auth/callback!`)
};

const bg_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Здравейте /auth/callback!`)
};

const ru_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Привет, /auth/callback!`)
};

const uk_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Привіт /auth/callback!`)
};

const ar_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مرحبًا /auth/callback!`)
};

const hi_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नमस्ते /auth/callback!`)
};

const th_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สวัสดี /auth/callback!`)
};

const ja_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`こんにちは /auth/callback!`)
};

const zh_cn2_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您好 /auth/callback!`)
};

const zh_hant1_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您好 /auth/callback！`)
};

const ko_auth_callback_placeholder = /** @type {(inputs: Auth_Callback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/auth/callback에 오신 것을 환영합니다!`)
};

/**
* | output |
* | --- |
* | "Hello /auth/callback!" |
*
* @param {Auth_Callback_PlaceholderInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const auth_callback_placeholder = /** @type {((inputs?: Auth_Callback_PlaceholderInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Callback_PlaceholderInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_auth_callback_placeholder(inputs)
	if (locale === "ms") return ms_auth_callback_placeholder(inputs)
	if (locale === "da") return da_auth_callback_placeholder(inputs)
	if (locale === "de") return de_auth_callback_placeholder(inputs)
	if (locale === "en-US") return en_us2_auth_callback_placeholder(inputs)
	if (locale === "es-ES") return es_es2_auth_callback_placeholder(inputs)
	if (locale === "es-MX") return es_mx2_auth_callback_placeholder(inputs)
	if (locale === "fil") return fil_auth_callback_placeholder(inputs)
	if (locale === "fr") return fr_auth_callback_placeholder(inputs)
	if (locale === "it") return it_auth_callback_placeholder(inputs)
	if (locale === "hu") return hu_auth_callback_placeholder(inputs)
	if (locale === "nl") return nl_auth_callback_placeholder(inputs)
	if (locale === "no") return no_auth_callback_placeholder(inputs)
	if (locale === "pl") return pl_auth_callback_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_auth_callback_placeholder(inputs)
	if (locale === "pt") return pt_auth_callback_placeholder(inputs)
	if (locale === "ro") return ro_auth_callback_placeholder(inputs)
	if (locale === "fi") return fi_auth_callback_placeholder(inputs)
	if (locale === "sv") return sv_auth_callback_placeholder(inputs)
	if (locale === "vi") return vi_auth_callback_placeholder(inputs)
	if (locale === "tr") return tr_auth_callback_placeholder(inputs)
	if (locale === "cs") return cs_auth_callback_placeholder(inputs)
	if (locale === "bg") return bg_auth_callback_placeholder(inputs)
	if (locale === "ru") return ru_auth_callback_placeholder(inputs)
	if (locale === "uk") return uk_auth_callback_placeholder(inputs)
	if (locale === "ar") return ar_auth_callback_placeholder(inputs)
	if (locale === "hi") return hi_auth_callback_placeholder(inputs)
	if (locale === "th") return th_auth_callback_placeholder(inputs)
	if (locale === "ja") return ja_auth_callback_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_auth_callback_placeholder(inputs)
	if (locale === "zh-Hant") return zh_hant1_auth_callback_placeholder(inputs)
	return ko_auth_callback_placeholder(inputs)
});
export { auth_callback_placeholder as "auth.callback.placeholder" }